<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Age</span>
        <span v-copy="getAllOptionName27('age', quoteForm.age_id)">{{ getAllOptionName27('age', quoteForm.age_id) }}</span>
      </div>
      <div class="tr">
        <span>Occupation</span>
        <span v-copy="getAllOptionName27('occupation', quoteForm.occ_id)">{{ getAllOptionName27('occupation', quoteForm.occ_id)  }}</span>
      </div>
      <div class="tr">
        <span>
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      const benefitsList = this.quoteForm.benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName27('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
</style>
